import { FunctionComponent } from "react";

interface FooterLinkProps {
  name: string;
}

const FooterLink: FunctionComponent<FooterLinkProps> = ({ name }) => {
  return (
    <div className="mt-4 cursor-pointer tracking-tight">
      <p className="text-base leading-6 text-gray-500 hover:text-gray-900">
        {name}
      </p>
    </div>
  );
};

export default FooterLink;
